<template>
  <component :is="showPage" v-if="pageType" />
</template>

<script>
import {
  defineComponent,
  computed,
  onMounted,
  ref,
} from "@vue/composition-api";

import { useStore } from "@/components/use/base";

import CommonMember from "./page/CommonMember.vue";
import Weicai from "./page/Weicai.vue";
import JiaYing from "./page/JiaYing.vue";
import Xyr from "./page/Xyr.vue";

export default defineComponent({
  components: {
    CommonMember,
    Weicai,
    JiaYing,
    Xyr,
  },
  setup() {
    const pageType = ref("");
    const store = useStore();

    const showPage = computed(() => {
      return pageType.value;
    });

    const namespaceGroup = computed(
      () => store.state.namespaceInfo.namespace_group_en
    );

    onMounted(() => {
      pageType.value =
        { weicai: "Weicai", jiayin: "JiaYing", zhongji: "Xyr" }[
          namespaceGroup.value
        ] || "CommonMember";
    });

    return { showPage, pageType };
  },
});
</script>

<style scoped lang="less">
</style>
